import { render, staticRenderFns } from "./NOSComponent.vue?vue&type=template&id=c76f6d6a"
import script from "./NOSComponent.vue?vue&type=script&lang=js"
export * from "./NOSComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c76f6d6a')) {
      api.createRecord('c76f6d6a', component.options)
    } else {
      api.reload('c76f6d6a', component.options)
    }
    module.hot.accept("./NOSComponent.vue?vue&type=template&id=c76f6d6a", function () {
      api.rerender('c76f6d6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/pluginFree/NOSComponent.vue"
export default component.exports